import { APIClient } from '@/infrastructure/network/Upstream/APIClient'

export class UpstreamGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
